import { TIER_FINDING_COUNTS } from "@/lib/qoeCatalogue.generated";

interface ScopeBadgeProps {
  tier?: "lite" | "focused" | "full" | null;
  override?: boolean;
  unconfigured?: boolean;
}

// Point counts come from the catalogue (17/54/74), never typed here — this
// badge advertised stale counts for the whole of FINDINGS-DOMAIN-1 Session 1-2.
const CONFIG = {
  lite:    { label: "QoE Lite",    classes: "bg-green-100 text-green-800 border border-green-200" },
  focused: { label: "Focused QoE", classes: "bg-amber-100 text-amber-800 border border-amber-200" },
  full:    { label: "Full QoE",    classes: "bg-blue-100 text-blue-800 border border-blue-200" },
};

export function ScopeBadge({ tier, override, unconfigured }: ScopeBadgeProps) {
  if (unconfigured || !tier) {
    return (
      <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs
                       bg-amber-50 text-amber-700 border border-amber-200">
        ⚠ Scope not set
      </span>
    );
  }
  const { label, classes } = CONFIG[tier];
  // WP-4 (D7, QOE-DEV-BATCH-1): "pts" collided with the complexity score's
  // "pts" elsewhere in the product — this badge shows MIR points, a different
  // quantity. Word it the same way ScopeSelector.tsx already does.
  const pts = `${TIER_FINDING_COUNTS[tier]} MIR points`;
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium ${classes}`}>
      {label} · {pts}{override ? " ✎" : ""}
    </span>
  );
}
